export function normalizeApiData(data) {
  return {
    id: data.id,
    name: data.name,
    description: data.description,
    // isDefault: data?.isDefault?.hasOwnProperty('value') ? data.isDefault.value : data.isDefault,
  };
}
